import React from "react";
import { useHistory } from 'react-router-dom';
import { useState } from "react";
import { useSharedDataContext } from "../SharedDataContext";
import { CommaSeprator } from "../utility/utilityFunction";

const QuoteCard = ({ sharedData, quoteData, RemoveAddonFromQuoteCard, HideQuotes, showPlanDetail }) => {
    const { setSharedQuoteData } = useSharedDataContext();
    const history = useHistory();
    const GotoProposal = () => {

        sessionStorage.removeItem('sharedQuoteData');
        setSharedQuoteData(quoteData);
        history.push({
            pathname: "/proposal",
            state: {
                quoteData: quoteData,
                sharedData: sharedData
            }
        });
    };

    const [addonCoversNames] = useState({
        ThirdPartyLiabilityCover: "Third Party Liability Cover",
        PersonalBelongingsCover: "Lost & Stolen Cover",
        EmergencyPetMindingCover: "Emergency Pet Minding Cover",
        VeteneryConsultationOrDoctorOnCallCover: "Veterinary Consultation On Call Cover",
        FuneralCostCover: "Funeral Cost Cover",
        TerminalDiesease: "Terminal Disease",
        LongTermCover: "Long Term Cover",
    });

    const checkCoverage = (obj) => {
        if (obj !== undefined && obj !== null) {

            return Object.values(obj).some(value => value);
        } else return false;
    };


    const insurer = quoteData;
    const isShowBaseCover = checkCoverage(sharedData?.AddonsSelected);
    return (
        <div className="quotesBoxesMain my-3">
            <div className="HLT_CUST_Head">
                <p>{insurer.PlanName}</p>
                <div className="IconContainer">
                    <small className="hideIcon EyeInfo" onClick={() => HideQuotes(insurer.InsurerID)}><i className="fas fa-minus-circle"></i><span>Hide Quote</span></small>
                </div>
            </div>
            <div className="HLT_CUST_Middle">
                <div className="card_innerBox">
                    <div className="HCM_Logo">
                        <div className="Qlogo"><img src={insurer.Logo} alt="Insurer Logo" /></div>
                    </div>
                    {isShowBaseCover &&
                        <div className="HCM_Feature">
                            <h3>Add-Ons</h3>
                            <ul>
                                {Object.entries(sharedData?.AddonsSelected).map(([addonName, value]) => (
                                    <>
                                        {value && <li>
                                            <div className="QuestionPopup">
                                                <span>{addonCoversNames[addonName]}</span>
                                                <span className="mx-2">{addonName == "ThirdPartyLiabilityCover" ? `${insurer.ThirdPartyAmt > 0 ? "₹" + CommaSeprator(Math.round(insurer.ThirdPartyAmt)) : ""}` : addonName == "LongTermCover" ? `${insurer.AmtLongTerm > 0 ? "₹" + CommaSeprator(Math.round(insurer.AmtLongTerm)) : ""}` : addonName == "EmergencyPetMindingCover" ? ` ${insurer.AmtEmergencyPetMinding > 0 ? "₹" + CommaSeprator(Math.round(insurer.AmtEmergencyPetMinding)) : ""}` : addonName == "VeteneryConsultationOrDoctorOnCallCover" ? `${insurer.AmtVeteneryConsultationOrDoctorOnCall > 0 ? "₹" + CommaSeprator(Math.round(insurer.AmtVeteneryConsultationOrDoctorOnCall)) : ""}` : "₹" + CommaSeprator(Math.round(insurer[`Amt${addonName}`]))}</span>
                                                {/*<span className="RemoveAddon text-dark cursor-Pointer" onClick={() => { RemoveAddonFromQuoteCard(addonName); }}><i class="fas fa-times"></i></span>*/}
                                               
                                                {/*<div className="QuestionPopupInner">
                                                <div className="head ng-binding"></div>
                                                <div className="body"><p className="ng-binding"></p></div>
                                            </div>*/}
                                            </div>
                                        </li>}
                                    </>
                                ))}

                            </ul>
                        </div>
                    }
                    
                </div>
                <div className="card_innerBox">
                    <div className="HCM_SumIns">
                        <p>
                            Cover Value<br />
                            <span>₹{CommaSeprator(Math.round(insurer.SumInsured))}</span>
                        </p>
                    </div>
                    <div className="HCM_Premium">
                        <div className="QPremium text-center">
                            <a className="btn SMCLarg QuoteBtn btn-block" href="javascript:void(0)" onClick={GotoProposal} disabled="">₹<span className="buyme ng-binding">{CommaSeprator(Math.round(insurer.Premium))} <small className="fw-normal">/yr</small></span> {/*<i className="fas fa-chevron-right"></i>*/}{/*<small className="PremiumBuyNow">Buy Now</small>*/}</a>
                        </div>
                        <div className="PerMonthVal"><span>₹{CommaSeprator(Math.round(Math.round(insurer.Premium) / 12))}/month</span></div>
                    </div>
                </div>
            </div>


            <div className="HLT_CUST_Bottom">
                <div className="HLT_CUST_H_List">
                    <a href={insurer.Brochure} target="blank" >
                        <span className="QuoteLinks mx-1">Brochure</span>
                        <img src={require("../../assets/images/Icon-download.svg").default} />
                </a>
                </div>
                <div className="HLT_CUST_H_List planDetailsBtn">
                    <span className="QuoteLinks " onClick={() => showPlanDetail(insurer.InsurerID)}>Plan Details</span>
                   {/* <img src={require("../../assets/images/Left.svg").default} />*/}
                </div>
            </div>
        </div>
    )
}
export default QuoteCard;